export {
  DynamicSignUpFields as default,
  DynamicSignUpFields,
} from "@blueskydataplatform/shared-ui/components/sign-up-fields/dynamic-sign-up-fields";
